export enum ExtensionArtifactInvocationStatus {
  Success = "success",
  InputValidationFailed = "input_validation_failed",
  ExecutionFailed = "execution_failed",
  OutputValidationFailed = "output_validation_failed",
}
